/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.VUE_APP_NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`);
}
